
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"fill":"#F43040","d":"M23.73 18.333L13.732 1c-.768-1.333-2.695-1.333-3.464 0L.27 18.333c-.768 1.331.193 3 1.732 3h19.995c1.537 0 2.503-1.666 1.733-3zM12 18.667A1.333 1.333 0 1112 16a1.333 1.333 0 010 2.667zm1.593-9.934l-.533 5.333a.665.665 0 01-.663.6h-.792a.665.665 0 01-.663-.6l-.534-5.333A.67.67 0 0111.07 8h1.86a.665.665 0 01.664.733z"}}),_c('path',{attrs:{"fill":"#FFF","fill-opacity":".87","d":"M12.93 8h-1.86a.665.665 0 00-.664.733l.534 5.333c.034.341.32.6.663.6h.792c.343 0 .63-.259.663-.6l.534-5.333A.67.67 0 0012.93 8zM12 16a1.333 1.333 0 100 2.667A1.333 1.333 0 0012 16z"}})])])
          )
        }
      }
    